export default __webpack_public_path__ + "static/media/NIE-ChatBot-icon.de2122e0.svg";